import { Component, EventEmitter, Output } from '@angular/core';
import { FriendService } from '../../services/friend.service';
import { ToasterService } from '../../services/toaster.service';

@Component({
    selector: 'pop-addfriend',
    template: `
    <div class="user-popover-outline">
        <div class="user-popover">
            <div class="bar-header">
                <h1 class="title ly_pop_title">친구추가</h1>
                <a class="ly_pop_close" (click)="closePopover()"><mat-icon class="mat-icon-30 btn_close" svgIcon="xi-close"></mat-icon></a>
            </div>
            <form name="addFriendForm" #f="ngForm">
                <div class="pop-body">
                    <div id="friend_add" class="friend_add">
                    <mat-form-field floatLabel="never">
                        <input matInput type="text" name="friend_nick" placeholder="닉네임을 입력하세요" [(ngModel)]="friendNick" required />
                    </mat-form-field>
                        <p class="desc">닉네임이 변경되어도 친구는 유지됩니다.</p>
                    </div>
                </div>
                <div class="pop-footer">
                    <button mat-button class="full btn_create" [disabled]="!f.form.valid" (click)="addFriend()"><span style="color: #fff;">추가</span></button>
                </div>
            </form>
        </div>
    </div>`,
    styleUrls: ['style.scss']
})    // template: `탭플리트를 생성해 보자`,

export class LayerPopAddFriendComponent {
    @Output() popclosed = new EventEmitter();

    friendNick: string;
    constructor(
        private friendService: FriendService,
        private toasterService: ToasterService
    ) { // private navParams:
    }

    // 친구 추가
    addFriend() {
        const params = {mode: 'friend', flag: 'add', mb_nick: this.friendNick};
        this.friendService.SetRelation(params, (obj: any) => {
            if (obj.result === true) {
                this.friendNick = '';
                this.toasterService.showToaster('info', '친구로 추가되었습니다.');
                this.closePopover();
            } else {
                this.toasterService.showToaster('error', obj.message);
            }
        });
    }

    closePopover() {
        // 현재 팝업창 닫기 ()
        this.popclosed.emit();
    }
}
